import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;

const FAQAdd = () => {
  const { id } = useParams(); // To get the faq ID from the URL for edit mode
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);

  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  // Effect to check if the ID exists and fetch the faq data for edit mode
  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      // Fetch the faq details if ID is present
      axios
        .get(`${API_URL}/getFAQById/${id}`)
        .then((response) => {
          const faq = response.data.data;
          setQuestion(faq.question);
          setAnswer(faq.answer || ""); // Optional answer
        })
        .catch((error) => {
          console.error("Error fetching FAQ:", error);
          toast.error("Error fetching FAQ details", { autoClose: 2000 });
        });
    }
  }, [id]);

  // Handle form submission (both add and edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure question and link are filled (required fields)
    if (!question) {
      toast.error("Question is a required field", { autoClose: 2000 });
      return;
    }

    try {
      const faqData = {
        question,
        answer,
      };

      // If in edit mode, update the existing faq
      if (isEditMode) {
        await axios.put(`${API_URL}/updateFAQ/${id}`, faqData, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        toast.success("FAQ updated successfully", { autoClose: 2000 });
      } else {
        // If in create mode, create a new faq
        await axios.post(`${API_URL}/createFAQ`, faqData, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        toast.success("FQA created successfully", { autoClose: 2000 });
      }

      // Redirect to the list of faqs after submission
      navigate("/faq");
    } catch (error) {
      console.error("Error saving FAQ :", error);
      toast.error("Error saving FAQ", { autoClose: 2000 });
    }
  };

  return (
    <div className="container mt-5">
                                    <div className='mb-4 flex items-center gap-x-3'>
  <button
  type="button"
  onClick={() => window.history.back()}
  className="text-white focus:ring-4 focus:outline-none font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2"
  style={{
    backgroundColor: '#1c2534',
  }}
  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a3548'}  // lighter shade on hover
  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1c2534'}
>
  <svg
    className="w-4 h-4"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 10"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13 5H1m0 0l4-4M1 5l4 4"
    />
  </svg>
  <span className="sr-only">Go Back</span>
</button>

  <h2 className='text-lg font-bold mb-0'> {isEditMode ? "Edit Faq" : "Create New Faq"}</h2>
  </div>
      {/* <h2>{isEditMode ? "Edit faq" : "Create New faq"}</h2> */}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Question</label>
          <input
            type="text"
            className="form-control"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Answer</label>
          <textarea
            className="form-control"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary mt-3">
          {isEditMode ? "Update FAQ" : "Save FAQ"}
        </button>
      </form>
    </div>
  );
};

export default FAQAdd;
